import { CategoryGroupIds } from './../../../modules/shared/constants/category-groupid.constants';
import { HttpClient } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmOpportunityService {

  constructor(private http: HttpClient) { }

  getAllTypes() {
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
  }

  getForecastCategories() {
    return this.http.get<any>(`${environment.opportunityUrl}Category?groupId=${CategoryGroupIds.OpportunityForeCastCategory}`);
  }


}

